<template>
  <div>
  <div data-option-section="" class="px-5 py-7 mx-auto mt-4 max-w-6xl sm:px-5 lg:px-16 md:pt-14 md:pb-9"
    id="the-products-test">

    <div v-if="Object.keys(state.items).length > 1"
      class="flex w-full text-2xl text-white rounded bg-brownCoffee lg:text-26 xl:text-32 sm-max:flex-col">
      <div
        class="relative px-10 py-0 text-xl uppercase bg-white bg-opacity-20 xs-max:pt-3 sm:py-4 sm:text-lg lg:text-25 xs-max:font-bold md-max:text-center">
        Step 1
      </div>
      <div
        class="px-14 py-0 text-xl xs-max:pb-3 sm:py-4 sm:text-lg lg:text-25 xs-max:bg-white xs-max:bg-opacity-20 md-max:text-center">
        Choose a Coffee
      </div>
    </div>
    <!-- STEP 1 -->
    <div class="grid grid-cols-12 gap-x-6 gap-y-6 justify-center mt-6 mb-8 text-center sm:gap-y-4"
      v-if="Object.keys(state.items).length > 1">
      <div class="relative col-span-12 w-full sm-max:mb-0 lg:col-span-6" v-for="(item, index) in state.items"
        :key="index">


        <nuxt-img v-if="item.SubName == 'DR PICK'"
          :class="state.active.items == index ? '-top-3 z-[4] -left-3' : '-top-2 z-[4] -left-2'"
          class="absolute object-contain min-w-[100px]" loading="lazy" format="webp" alt="" src="Group-21.png" />

        <nuxt-img v-if="item.SubName == 'BEST SELLER'"
          :class="state.active.items == index ? '-top-3 z-[4] -left-3' : '-top-2 z-[4] -left-2'"
          class="absolute object-contain min-w-[100px]" loading="lazy" format="webp" alt="" src="Component-12.png" />
        <label :data-event-label="item.Name" data-event-action="step_1_choice" data-event-name="experiment_event" :data-testid="'step1-choice-'+index"
          class="flex relative flex-col items-center px-3 py-4 h-full rounded-lg border-2 cursor-pointer border-grayBorder lg:gap-4 md:gap-1 sm:flex-row sm-max:pb-4"
          :class="state.active.items == index ? 'shadow-custom sm:shadow-none' : ''">
          <div class="flex justify-between items-center w-full basis-3/12 sm:px-3 md:px-2 lg:gap-4 lg:px-0">
            <input type="radio" :name="'test8-step4' + uniqueId" class="hidden" :id="'test8-' +index + uniqueId + 'roastnew'" :checked="state.active.items == index"
              @click="setProduct(index)" :value="index" />
            <span class="hidden absolute inset-0 -m-0.5 rounded-lg border-2 border-greenActive2 bg-greenActive show"
              style="
                -webkit-box-shadow: 0px 0px 0px 3px rgba(123, 189, 65, 1);
                -moz-box-shadow: 0px 0px 0px 3px rgba(123, 189, 65, 1);
                box-shadow: 0px 0px 0px 3px rgba(123, 189, 65, 1);
              "></span>
            <span
              class="hidden w-6 h-6 rounded-full border lg:w-10 lg:h-7 md:w-8 sm:w-7 sm:h-6 showbg green sm:block"></span>
            <div class="w-full">
              <nuxt-img class="object-contain mx-auto w-32 sm:w-24 sm:max-w-20 lg:max-w-24 min-h-20 md:mx-left"
                width="196" height="285" loading="lazy" format="webp" sizes="sm:218px md:218px lg:218px xl:196px" alt=""
                :src="item.Image.url" />
            </div>
          </div>
          <div class="grid gap-y-3 justify-start md-max:basis-9/12 lg:col-span-6 sm:gap-y-2">
            <h3 class="pt-2 text-2xl leading-6 capitalize sm:text-left sm:text-22">{{ item.Name }}</h3>
            <div class="flex gap-1 items-center text-xs">
              <ElementsStars :handle="item.Name" />
            </div>

            <div class="grid gap-3 leading-5" v-html="item.ExtraData?.htmlContent"></div>
            <div :class="state.active.items == index ? 'bg-greenActive2' : 'bg-[#C2C2C2]'"
              class="leading-[36px] pb-1 w-full font-ww-medium text-center items-center absolute left-0 block text-3xl font-bold sm:tracking-[10px] tracking-[7px] text-white uppercase rounded-b-lg sm:hidden justify-center -bottom-1">
              <span class="text-center">
                {{ state.active.items == index ? 'SELECTED' : 'SELECT' }}
              </span>
            </div>
          </div>
        </label>
      </div>
    </div>

    <div v-if="Object.keys(state.variants).length > 1">
      <!-- STEP 2 -->
      <div
        class="flex mt-2 w-full text-2xl text-white rounded bg-brownCoffee lg:text-26 xl:text-32 sm-max:flex-col sm-max:mt-8">
        <div
          class="relative px-10 py-0 text-xl uppercase bg-white bg-opacity-20 xs-max:pt-3 sm:py-4 sm:text-lg lg:text-25 xs-max:font-bold md-max:text-center">
          {{ Object.keys(state.items).length > 1 ? "Step 2" : "Step 1" }}
        </div>
        <div
          class="px-14 py-0 text-xl xs-max:pb-3 sm:py-4 sm:text-lg lg:text-25 xs-max:bg-white xs-max:bg-opacity-20 md-max:text-center">
          Ground or Beans?
        </div>
      </div>

      <div class="grid grid-cols-12 gap-x-6 gap-y-6 justify-center mt-6 mb-8 text-center sm:gap-y-4">
        <div class="col-span-12 w-full lg:col-span-6" v-for="(item, index) in state.variants" :key="index">
          <label data-option="12 oz Ground" :data-event-label="item.Name" data-event-action="step_2_choice" :data-testid="'step2-choice-'+index"
            data-event-name="experiment_event"
            :class="state.active.variants == index ? 'border-2 shadow-custom' : 'border-2'"
            class="flex relative flex-col items-center px-3 py-4 h-full rounded-lg border-2 cursor-pointer border-grayBorder sm:shadow-none lg:gap-4 md:gap-1 sm:flex-row sm-max:pb-4">
            <div
              class="flex justify-between items-center w-full sm:w-6/12 md:w-4/12 lg:w-5/12 sm:px-3 md:px-2 lg:gap-4 lg:px-0">
              <input type="radio" :name="'test8-step5' + uniqueId" class="hidden" :id="'test8-'+item.Name + uniqueId" :checked="state.active.variants == index"
                @click="setType(index)" :value="index" />
              <span
                class="hidden absolute inset-0 -m-0.5 rounded-lg border-4 border-greenActive2 bg-greenActive show"></span>
              <span
                class="hidden w-6 h-6 rounded-full border lg:w-7 lg:h-7 md:w-6 sm:w-6 sm:h-6 showbg green sm:block"></span>
              <nuxt-img :src="item.Image.url"
                class="object-contain mx-auto w-32 sm:w-36 lg:w-24 xl:w-28 lg:max-w-24 md-max:w-36 xl:max-w-36 md:mx-left"
                width="196" height="86" loading="lazy" format="webp" sizes="sm:234px md:234px lg:234px xl:234px"
                alt="product" />
            </div>
            <div class="grid gap-y-3 justify- sm:w-6/12 md:w-8/12 lg:col-span-6 sm:gap-y-2">

              <h3 class="pt-2 text-2xl leading-6 capitalize sm:text-left sm:text-22">
                {{ item.Name }}
              </h3>

              <p class="mb-8 text-sm leading-5 text-left sm:mb-0" v-html="item.Text">
              </p>

              <p class="mt-4 mb-6 text-sm text-left sm:mb-0" v-if="state.isSubscription && hasSellingPlans">
                <span class="font-bold sm:text-xl text-lg bg-[#AC6143] block p-4 text-white">Get A Box Of Our Curated
                  Seasonal Favorites For $21.08 per bag! (Normally 27.95)</span>
              </p>

              <div :class="state.active.variants == index ? 'bg-greenActive2' : 'bg-[#C2C2C2]'"
                class="leading-[36px] pb-1 w-full text-center font-ww-medium items-center absolute left-0 block text-3xl font-bold sm:tracking-[10px] tracking-[7px] text-white uppercase rounded-b-lg sm:hidden justify-center -bottom-1">
                <span class="text-center">
                  {{ state.active.variants == index ? 'SELECTED' : 'SELECT' }}
                </span>
              </div>
            </div>
          </label>
        </div>
      </div>
    </div>

    <!-- STEP 3 -->
    <div v-if="Object.keys(FilteredPacks).length > 1"
      class="flex mt-3 w-full text-2xl text-white rounded bg-brownCoffee lg:text-26 xl:text-32 sm-max:flex-col sm-max:mt-8">
      <div
        class="relative px-10 py-0 text-xl uppercase bg-white bg-opacity-20 xs-max:pt-3 sm:py-4 sm:text-lg lg:text-25 xs-max:font-bold md-max:text-center">
        Step 3

      </div>
      <div
        class="px-14 py-0 text-xl xs-max:pb-3 sm:py-4 sm:text-lg lg:text-25 xs-max:bg-white xs-max:bg-opacity-20 md-max:text-center">
        How many bags?
      </div>
    </div>

    <div class="grid grid-cols-12 gap-x-6 gap-y-6 justify-center mt-6 mb-8 text-center sm:gap-y-2"
      v-if="Object.keys(FilteredPacks).length > 1">
      <div class="col-span-12 w-full lg:col-span-6" v-for="(item, index) in FilteredPacks" :key="index">
        <label data-index="0" :class="state.active.packs == index ? 'border-2 shadow-custom' : 'border-2'" :data-testid="'step3-choice-'+index"
          :data-event-label="item.Name" data-event-action="step_3_choice" data-event-name="experiment_event"
          class="grid relative grid-cols-12 items-center px-3 pt-4 h-full rounded-lg cursor-pointer border-grayBorder sm:shadow-none lg:gap-4 md:gap-1 sm:flex-row">

          <div
            class="flex col-span-12 justify-between items-center w-full sm:col-span-6 md:col-span-4 lg:col-span-5 sm:px-3 md:px-2 lg:gap-4 lg:px-0">
            <input type="radio" :name="'test8-step6' + uniqueId" class="hidden" :id="'test8-item' + index + uniqueId" :checked="state.active.packs == index"
              @click="setPack(index)" :value="index" />
            <span
              class="hidden absolute inset-0 -m-0.5 rounded-lg border-4 border-greenActive2 bg-greenActive show"></span>
            <span
              class="hidden w-6 h-6 rounded-full border lg:w-7 lg:h-7 md:w-6 sm:w-6 sm:h-6 showbg green sm:block"></span>
            <nuxt-img :src="item.Image.url"
              class="object-contain mx-auto w-48 sm:w-36 lg:w-24 xl:w-32 lg:max-w-24 md-max:w-36 xl:max-w-36 md:mx-left"
              loading="lazy" format="webp" width="284" height="224" sizes="sm:284px md:300px lg:300px xl:284px"
              alt="product" />
          </div>

          <div class="grid col-span-12 gap-y-3 sm:col-span-6 md:col-span-8 lg:col-span-7 sm:gap-y-2">
            <span class="absolute inset-0 border-2 border-[#7bbd41] rounded-lg -m-0.5 hidden show" style="
                -webkit-box-shadow: 0px 0px 0px 3px rgba(123, 189, 65, 1);
                -moz-box-shadow: 0px 0px 0px 3px rgba(123, 189, 65, 1);
                box-shadow: 0px 0px 0px 3px rgba(123, 189, 65, 1);
              "></span>

            <h3 class="pt-2 text-2xl leading-6 capitalize sm:text-left sm:text-22">
              {{ item.Name }}
            </h3>

            <p v-if="item.Text" class="mb-4 text-sm text-left sm:mb-0" v-html="item.Text"></p>
            <div :class="state.active.packs == index ? 'bg-greenActive2' : 'bg-[#C2C2C2]'"
              class="leading-[36px] pb-1 font-ww-medium w-full text-center items-center absolute left-0 block text-3xl font-bold sm:tracking-[10px] tracking-[7px] text-white uppercase rounded-b-lg sm:hidden justify-center -bottom-1">
              <span class="text-center">
                {{ state.active.packs == index ? 'SELECTED' : 'SELECT' }}
              </span>
            </div>
          </div>

          <div class="col-span-12 mb-8 sm:mb-0">
            <div class="w-full">
              <div
                class="flex flex-row gap-4 justify-center items-center px-6 py-4 -mx-3 mt-2 space-y-0 text-white xs-max:px-2 xs-max:grid xs-max:grid-cols-3 sm:rounded-b-lg pb- sm-max:py-3 bg-lifeboost-green-mid">
                <span class="leading-5 line-through sm:mt-1 md:text-lg text-15">{{
      setPrice(item)
    }}</span>

                <div v-if="!(!item.SaleRibbon || /^\s*$/.test(item.SaleRibbon))"
                  class="text-2xl font-bold special-banner">
                  {{ item?.SaleRibbon }}
                </div>

                <span class="flex justify-center items-center text-2xl font-bold leading-5 lg:text-2xl md:text-22"
                  v-html="item.Price"></span>
                <div class="sm:mt-1 md:text-lg text-15" v-html="item?.Offer"></div>
              </div>
            </div>
          </div>
        </label>
      </div>

      <div class="col-span-12 -mt-4 text-center sm:-mt-2 sm:text-right">
        <p class="pt-1 w-full text-sm italic">*On Continental US orders only</p>
      </div>
    </div>
    <div v-if="state.isSubscription && hasSellingPlans">
      <div class="text-lg text-red-400 border-red-400">
        <p class="m-auto mt-4 mb-4 text-lg font-medium leading-tight text-gray-900 sm-max:text-xl">
          {{ state.items[state.active.items].Name }} by Lifeboost is an ongoing subscription service that
          is automatically charged each season <span class="font-bold">({{
      state.items[state.active.items].Variants[state.active.variants].Pack[state.active.packs].Price }}
            USD)</span> to the payment method
          provided until you cancel. Taxes, & shipping fees. You may cancel your subscription online at any time before
          your next bill date, or by contacting Lifeboost Coffee Support at 1-800-479-1596, or by contacting us
          <a class="underline text-link" target="_blank" href="https://lifeboostcoffee.com/pages/contact-us">here.</a>️
        </p>
      </div>
      <div class="flex flex-row justify-center my-10 space-x-6">
        <div class="flex items-start">
          <div class="flex items-center h-6">
            <input id="remember" aria-describedby="remember" type="checkbox"
              :class="['relative w-6 h-6 border drop-shadow-lg rounded cursor-pointer !p-3 !mt-4 bottom-1 bg-gray-50 focus:ring-3 focus:ring-primary-300', { 'highlight-checkbox': highlightCheckbox }]"
              v-model="checkboxChecked" @change="highlightCheckbox = false" required>
          </div>
        </div>
        <div class="max-w-md text-left text-xs !ml-4">
          <label for="remember" class="text-lg font-bold text-gray-700 cursor-pointer text-body font-gotham">
            By clicking "Join our club now", you are agreeing to our Terms of Use and Sale and
            <a class="text-link" href="https://lifeboostcoffee.com/pages/terms" target="_blank">
              Lifeboost Coffee Terms
            </a>
            and Conditions
          </label>
        </div>
      </div>
    </div>
    <button type="button" data-event-name="experiment_event" data-event-action="CTA Click | Add To Cart" data-testid="cta-button"
      data-event-label="cta_add_to_cart" data-cart-add=""
      class="p-3 py-1 mt-2 mb-0 w-full font-bold text-center text-white uppercase rounded shadow-md transition-all bg-orangebtn font-ww-medium sm-max:text-32 text-51 hover:opacity-75"
      @click="handleButtonClick($event)" :disabled="!stockCheck()"
      :class="(!stockCheck() && 'grayscale-1') || (highlightCheckbox && 'highlight-checkbox') || (devMode && 'split-test-outline')"
      style="box-shadow: 0 -4px 0 #c7642d inset">
      {{ !stockCheck() ? "OUT OF STOCK" : state.isSubscription ? "JOIN OUR CLUB NOW" : "ADD TO CART" }}
    </button>
  </div>
  <div class="relative flex items-center justify-center customPopup2 fixed w-full h-full z-[21474830004] left-0 top-0"
    v-show="state.upgrade.show" :class="state.upgrade.show ? 'active' : ''" id="tail">
    <UpsellRewardsTest8 :state="state" />
  </div>
</div>
</template>

<script setup>
/** 
 * @name SwatchesTest8.5
 * @description Used for Test 8.5 in Builder.io
 */

const props = defineProps({
  UrlLink: {
    type: String,
    default: 'swatches-test-upsell'
  },
})
const uniqueId = ref(generateUniqueId());

const runEngine = new Engine();
const route = useRoute();
const page = ref({ Products: { data: {} }, AOVBooster: [], PreselPack: null });
page.value = await runEngine.queryPage(
  props.UrlLink
);
const products = computed(() => {
  return Object.keys(page.value.Products).reduce(
    (r, v) => ({ ...r, [v]: page.value.Products[v] }),
    {}
  );
});

// Call loadReviews on component moun

const aovUpgrades = computed(() =>
  page.value.AOVBooster.length ? page.value.AOVBooster[0] : []
);
const Preselected = computed(() =>
  page.value.PreselPack !== null ? page.value.PreselPack - 1 : 0
);

const highlightCheckbox = ref(false);
const checkboxChecked = ref(false);

const state = reactive({
  layout: ref(""),
  layoutPopup: ref(""),
  subscriptionPage: ref(false),
  pageSteps: ref({}),
  items: products,
  upgrades: aovUpgrades,
  variants: products.value[0].Variants,
  packs: products.value[0].Variants[0].Pack.filter((obj) => obj.Active),
  images: products.value[0].Variants[0].variant.Gallery[0],
  unit: ref({
    beans: ["bag", "bags"],
    pods: ["box", "boxes"],
    ground: ["bag", "bags"],
    wholebeans: ["bag", "bags"],
    coffeeground: ["bag", "bags"],
    coffeebeans: ["bag", "bags"],
    coffeepods: ["box", "boxes"],
  }),
  currentUnit: ref(["bag", "bags"]),
  active: {
    items: 0,
    variants: 0,
    packs: Preselected.value,
    sellingPlan: 0,
  },
  upgrade: ref({
    UpSell: {},
    CrossSell: {},
    show: false,
  }),
  isSubscription: page.value.Subscription ?? false,
  regular: ref({}),
  trackingStack: ref({}),
});


const FilteredPacks = computed(() => {
  return state.items[state.active.items].Variants[
    state.active.variants
  ].Pack.filter((obj) => obj.Active);
});

// Modal object
const modal = reactive({
  show: true,
  page: true,
  product: {
    qty: 0,
    packName: "",
    Coupon: [],
    variantID: 40029155524668
  },
  upsell: {
    show: true,
    activate: false,
  },
  crosssell: {
    show: false,
    variantId: 32453656150076,
    activate: false,
  }
});

// const setProduct = (index) => {
//   const newPacks = products.value[index].Variants[0].Pack.filter((obj) => obj.Active);
// state.packs.splice(0, state.packs.length, ...newPacks);
//     }
// console.log(modal.upsell.show);
// Methods
const setProductModal = (input) => {
  modal.product = {
    qty: input.qty,
    packName: input.packName,
    Coupon: input.Coupon,
    variantID: input.variantID,
  };
  modal.crosssell.variantId = input.crossSellID;
};

const trackEvent = inject("trackEvent");

const setProduct = (index) => {
  index = parseInt(index);
  state.variants = products.value[index].Variants;
  state.active.items = parseInt(index);
  state.packs = products.value[index].Variants[0].Pack.filter(
    (obj) => obj.Active
  );
  state.images =
    products.value[index].Variants[0].variant.Gallery[0];
  state.active.variants = 0;
  state.active.packs = parseInt(Preselected.value);

};
const setType = (index) => {
  state.active.variants = parseInt(index);

  state.images =
    state.items[state.active.items].Variants[
      state.active.variants
    ].variant.Gallery[0];
  state.active.packs = parseInt(Preselected.value);
  state.packs = state.items[state.active.items].Variants[
    state.active.variants
  ].Pack.filter((obj) => obj.Active);
};

const setPack = (index) => {
  state.active.packs = parseInt(index);
};



const setPrice = (item) => {
  const amount = item.PackSize.replace("x", "");
  const sale =
    state.variants[state.active.variants].variant.VariantPrice;
  return "$" + (amount * sale).toFixed(2);
};



const stockCheck = () => {
  return state.items[state.active.items].Variants[state.active.variants].variant
    .inStock;
};

const hasSellingPlans = () => {

  return state.items[state.active.items].Variants[state.active.variants].variant.SellingPlans.length > 0;
}


const devMode = useCookie('devMode')

// Lifecycle hook onMounted (equivalent to init in Alpine.js)
onMounted(() => {
  runEngine.fetchProduct(["6938980876348", "6980372004924", "7148455624764", "8023271014460"]).then(() => {
    Object.keys(state.items).map((key) => {
      return state.items[key].Variants.map((variant, index) => {
        state.items[key].Variants[index].variant.inStock =
          runEngine.getInStock(variant.variant.VariantID);
        state.items[key].Variants[index].variant.SellingPlans =
          runEngine.getVariant(variant.variant.VariantID).sellingPlanAllocations.nodes;
      });
    });
  });

});

const addToCart = () => {
  const item = state.items[state.active.items];
  const variant = item.Variants[state.active.variants];
  const pack = variant.Pack[state.active.packs];
  const variantID = variant.variant.VariantID;
  const image = pack.Image.url


  if (typeof state.upgrades.CrossSellOffer !== "undefined") {
    document.body.style.overflow = "hidden";
    const upgradeOffer = products.value[state.active.items].Variants[
      state.active.variants
    ].Pack.filter(
      (obj) => obj.PackSize === "x" + pack.PackSize.replace("x", "") * 2
    );
    const oferTa = upgradeOffer[0];
    const CrossSellVariant = JSON.parse(
      state.upgrades.CrossSellOffer.VariantId.VariantSKU
    )[variant.Name.toLowerCase().includes("bean") ? "beans" : "ground"];
    setProductModal({
      qty: pack.PackSize.replace("x", ""),
      packName: pack.Name,
      Coupon: [oferTa.Coupon, pack.Coupon],
      variantID: variantID,
      crossSellID: CrossSellVariant,
    });
    state.upgrade = {
      product: item.Name,
      pack: pack.Name,
      variant: variant.Name,
      varID: variantID,
      quantity: pack.PackSize.replace("x", "") * 2,
      PackDiff: pack.PackSize.replace("x", "") / 2,
      UpSell: {
        PreHeader: state.upgrades.UpsellOffer.PreHeader,
        Header: state.upgrades.UpsellOffer.Header,
        SubHeader: state.upgrades.UpsellOffer.SubHeader,
        Image: state.upgrades.UpsellOffer.Image?.url || image,
        ButtonText: "Yes! Upgrade My Order",
      },
      CrossSell: {
        Body: state.upgrades.CrossSellOffer.Body,
        Header: state.upgrades.CrossSellOffer.Header,
        Image: state.upgrades.CrossSellOffer.Image.url,
        PricenSave: state.upgrades.CrossSellOffer.PricenSave,
        ButtonText: "Yes! Upgrade My Order",
      },
      // Image: pack.Image.url,
      OfferType: oferTa.OfferType,
      Discount: oferTa.Discount,
      Coupon: oferTa.Coupon,
      Price: oferTa.Price,
      show: true,
    };
  } else if (typeof state.upgrades.UpsellPackOffer !== "undefined") {
    document.body.style.overflow = "hidden";
    const xUpgradeQty = state.upgrades.UpsellPackOffer.filter(
      (obj) => obj.PackSizeRun === pack.PackSize
    );
    const oferTi = xUpgradeQty[0];
    const upgradeOffer = products.value[state.active.items].Variants[
      state.active.variants
    ].Pack.filter((obj) => obj.PackSize === oferTi.PackUpgrade);
    const oferTa = upgradeOffer[0];
    if (state.layoutPopup == "L02") {
      setProductModal({
        qty: pack.PackSize.replace("x", ""),
        packName: pack.Name,
        Coupon: [oferTa.Coupon, pack.Coupon],
        variantID: variantID,
      });
    }
    state.upgrade = {
      product: item.Name,
      pack: pack.Name,
      variant: variant.Name,
      varID: variantID,
      quantity: oferTi.PackUpgrade.replace("x", ""),
      PackDiff:
        oferTi.PackUpgrade.replace("x", "") -
        oferTi.PackSizeRun.replace("x", ""),
      PreHeader: oferTi.PreHeader,
      Header: oferTi.Header,
      SubHeader: oferTi.SubHeader,
      Image: oferTi.Image.url,
      // Image: pack.Image.url,
      OfferType: oferTa.OfferType,
      Discount: oferTa.Discount,
      Coupon: oferTa.Coupon,
      Price: oferTa.Price,
      ButtonText: oferTi.ButtonText,
      show: true,
    };
    state.regular = {
      product: item.Name,
      variant: variant.Name,
      pack: pack.Name,
      quantity: pack.PackSize.replace("x", ""),
      Coupon: pack.Coupon,
      varID: variantID,
    };
  } else {
    console.log("checkout paused")
    // runEngine.checkout(
    //   variantID,
    //   pack.PackSize.replace("x", ""),
    //   pack.Coupon,
    //   pack.Name,
    //   null,
    //   null,
    //   trackEvent
    // );
  }
};
const addToCartNoUpsell = () => {
const item = state.items[state.active.items];
const variant = item.Variants[state.active.variants];
const pack = variant.Pack[state.active.packs];
const variantID = variant.variant.VariantID;

// Checkout logic without upsell
console.log("Proceeding to checkout")
runEngine.checkout(
  variantID,
  pack.PackSize.replace("x", ""),
  pack.Coupon,
  pack.Name,
  null,
  null,
  trackEvent
);
};

const handleButtonClick = (event) => {
  addToCartNoUpsell();

    // track upsell offer view
    trackOffer.view({
      id: 1,
      name: 'Upsell and Cross-sell' // Double Order or Signature Bundle
    });
    builderTrackEvent("add_to_cart_button_click");
};



defineBuilderComponent({
    friendlyName: "SwatchesTest8-5",
    canHaveChildren: true,
    inputs: [
        {
            name: "UrlLink",
            type: "string",
            defaultValue: "swetches"
        }
    ]
});

function generateUniqueId() {
  return Math.random().toString(36).substring(2, 15);
}
</script>

<style scoped>
.highlight-checkbox {
  box-shadow: 0 0 5px red;
}

label * {
  cursor: pointer;
  pointer-events: none;
}

label input:checked~.show {
  display: block;
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}

label input:checked~.showbg {
  --tw-border-opacity: 1;
  border-color: rgba(255, 255, 255, var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: rgba(255, 255, 255, var(--tw-bg-opacity));
}

label input:checked~.showbg.gray {
  --tw-bg-opacity: 1;
  background-color: rgba(229, 231, 235, var(--tw-bg-opacity));
}

label input:checked~.showbg.green {
  --tw-border-opacity: 1;
  border-color: rgba(156, 163, 175, var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: rgba(123, 189, 65, var(--tw-bg-opacity));
}

label input:checked~.showbg.yellow {
  --tw-bg-opacity: 1;
  background-color: rgba(250, 204, 21, var(--tw-bg-opacity));
}

label input:checked~.showbg.cath {
  --tw-bg-opacity: 1;
  background-color: rgba(113, 63, 18, var(--tw-bg-opacity));
}

label input:checked~.showcolor-white {
  --tw-text-opacity: 1;
  color: rgba(255, 255, 255, var(--tw-text-opacity));
}

label input:checked~.text-o {
  --tw-text-opacity: 1;
  color: rgba(202, 138, 4, var(--tw-text-opacity));
}

label input:checked~.off {
  display: none;
}

.swatch {
  position: relative;
  cursor: pointer;
  border-radius: 0.5rem;
  border-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgba(156, 163, 175, var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: rgba(255, 255, 255, var(--tw-bg-opacity));
  padding-top: 0.625rem;
  padding-bottom: 0.625rem;
  padding-left: 0.875rem;
  padding-right: 0.875rem;
  font-weight: 500;
}

@media (min-width: 1024px) {
  .swatch {
    padding: 0.875rem;
  }
}

.swatch--tshirt {
  width: auto;
  width: initial;
  margin-bottom: 10px;
}

.swatch--active {
  --tw-bg-opacity: 1;
  background-color: rgba(229, 231, 235, var(--tw-bg-opacity));
}

.swatch--active svg {
  display: block !important;
}

.swatch--disabled {
  opacity: 0.15;
  text-decoration: line-through;
}

label input:checked~.swatch--packs {
  --tw-border-opacity: 1;
  border-color: rgba(255, 255, 255, var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: rgba(255, 255, 255, var(--tw-bg-opacity));
}

label input:checked~.swatch--packs.gray {
  --tw-bg-opacity: 1;
  background-color: rgba(229, 231, 235, var(--tw-bg-opacity));
}

label input:checked~.showbg.swatch--packs {
  --tw-bg-opacity: 1;
  background-color: rgba(229, 231, 235, var(--tw-bg-opacity));
}

label input:checked~.swatch--packs.green {
  --tw-border-opacity: 1;
  border-color: rgba(156, 163, 175, var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: rgba(123, 189, 65, var(--tw-bg-opacity));
}

label input:checked~.swatch--packs.yellow {
  --tw-bg-opacity: 1;
  background-color: rgba(250, 204, 21, var(--tw-bg-opacity));
}

label input:checked~.swatch--packs.cath {
  --tw-bg-opacity: 1;
  background-color: rgba(113, 63, 18, var(--tw-bg-opacity));
}

.swatch--packs {
  position: absolute;
  position: relative;
  top: 0px;
  right: 0px;
  bottom: 0px;
  left: 0px;
  z-index: 0;
  min-width: -moz-min-content;
  min-width: min-content;
  cursor: pointer;
  border-radius: 0.5rem;
  border-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgba(156, 163, 175, var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: rgba(255, 255, 255, var(--tw-bg-opacity));
  font-weight: 500;
}

.swatch--packs.swatch--active {
  --tw-bg-opacity: 1;
  background-color: rgba(229, 231, 235, var(--tw-bg-opacity));
}

.swatch--packs {
  padding: 15px 0 0 0;
  width: inherit;
}

.swatch {
  width: inherit;
}

.swatch--packs:nth-child(1) {
  padding: 15px 0 !important;
}

label input:checked~.off {
  display: none;
}

imglabel input:checked~.off[data-sizes="auto"] {
  display: none;
}

label.lazy__container input:checked~.off {
  display: none;
}

label input:checked~.text-o {
  --tw-text-opacity: 1;
  color: rgba(202, 138, 4, var(--tw-text-opacity));
}

.progress {
  background-color: #f5f5f5;
  border-radius: 3px;
  box-shadow: none;
}

.progress-bar {
  background-color: #2196f3;
  box-shadow: none;
}

@-webkit-keyframes progress-bar-stripes {
  from {
    background-position: 40px 0;
  }

  to {
    background-position: 0 0;
  }
}

@keyframes progress-bar-stripes {
  from {
    background-position: 40px 0;
  }

  to {
    background-position: 0 0;
  }
}

.progress-bar.active,
.progress.active .progress-bar {
  -webkit-animation: progress-bar-stripes 2s linear infinite;
  -o-animation: progress-bar-stripes 2s linear infinite;
  animation: progress-bar-stripes 2s linear infinite;
}

.progress-bar-striped,
.progress-striped .progress-bar {
  background-image: -webkit-linear-gradient(45deg,
      rgba(255, 255, 255, 0.15) 25%,
      transparent 25%,
      transparent 50%,
      rgba(255, 255, 255, 0.15) 50%,
      rgba(255, 255, 255, 0.15) 75%,
      transparent 75%,
      transparent);
  background-image: -o-linear-gradient(45deg,
      rgba(255, 255, 255, 0.15) 25%,
      transparent 25%,
      transparent 50%,
      rgba(255, 255, 255, 0.15) 50%,
      rgba(255, 255, 255, 0.15) 75%,
      transparent 75%,
      transparent);
  background-image: linear-gradient(45deg,
      rgba(255, 255, 255, 0.15) 25%,
      transparent 25%,
      transparent 50%,
      rgba(255, 255, 255, 0.15) 50%,
      rgba(255, 255, 255, 0.15) 75%,
      transparent 75%,
      transparent);
  background-size: 40px 40px;
}

.progress-bar-success {
  background-color: #00a968;
}

button.cart-popup-close:after {
  display: inline-block;
  content: "\00d7";
}

button.cart-popup-close {
  background: none;
  color: inherit;
  border: none;
  font-family: "Gruppo";
  color: #4e4e4e;
  font-size: 30px;
  position: absolute;
  right: 15px;
  top: 10px;
}

.upgrade-save-btn {
  cursor: pointer;
}

.product-image img,
.temp-fix {
  height: 200px;
  object-fit: contain;
}

.fix-height {
  height: 125px;
  object-fit: contain;
}

.fix-one-height {
  height: 240px;
  object-fit: contain;
}

[x-cloak] {
  display: none !important;
}

.grayscale-1 {
  filter: grayscale(1);
  pointer-events: none;
}

.flex-viewport {
  min-height: 550px;
}

@media only screen and (min-width: 500px) {
  .flex-viewport {
    min-height: 650px;
  }
}


@media only screen and (max-width: 580px) {
  .shadow-custom {
    box-shadow: 0 7px 4px 0 rgba(0, 0, 0, 0.25)
  }
}
</style>